export const menuActionType = {
    MENU_SEARCH:'MENU_SEARCH',
    MENU_CONFIG:'MENU_CONFIG',
};